import React, { lazy } from "react";
import MainLayout from "../Layouts/MainLayout/index.js";


import Cookies from "js-cookie";
import { PrivateRoute } from "./PrivateRoute.js";
import FallbackLoader from "../Components/loaders/FallbackLoader/FallbackLoader";
import DynamicDashboard from "./DynamicDashboard.js";
import { Outlet } from "react-router-dom";
import CreateBlog from "../Pages/CreateBlog/CreateBlog.jsx";
import AllBlogs from "../Pages/AllBlogs/AllBlogs.js";
import Blog from "../Pages/Blog/Blog.js";
import UserBlogs from "../Pages/UserBlogs/UserBlogs.js";
import Createuser from "../Pages/CreateUser/Createuser.jsx";
import Draft from "../Pages/Draft/Draft.js";
import StagingBlogs from "../Pages/StagingBlogs/StagingBlogs.jsx";
import BlogUrl from "../Pages/AllBlogs/BlogsUrl.jsx";
// Access individual query parameters
const urlParams = new URLSearchParams(window.location.search);

const Dashboard = lazy(() => import("../Pages/Home/Home.jsx"));


const MainRoutes = [
  {
    path: "/",
    element: <PrivateRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            index: true,
            element: (
              <React.Suspense fallback={<FallbackLoader />}>
                <DynamicDashboard />
              </React.Suspense>
            ),
          },
          {
            path: "create-blog",
            element: (
              <React.Suspense fallback={<FallbackLoader />}>
                <CreateBlog />
              </React.Suspense>
            ),
          },
          {
            path:"your-blog",
            element:<UserBlogs/>
          },
          {
            path:"staging-blog",
            element:<StagingBlogs/>
          },
          {
            path:"blog-details",
            element:<Blog/>
          },
          {
            path:"create-user",
            element:<Createuser/>
          },
          {
            path:"draft",
            element:<Draft/>
          },
           {
            path:"blogs-url",
            element:<BlogUrl/>
          }
        ],
      },
    ],
  },
];

export default MainRoutes;
